import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/brightcubes.webp';
import screenshot_target from '../../../images/letterfunnel/alexverstappen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Alex Verstappen"
      firstname="Alex"
      companyname="Bright Cubes"
      competition="Inspark en Xebia"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/alexverstappen.js